import axios from "axios";
const apiURL = process.env.VUE_APP_API_URL + "auditlogs/";
import authHeader from "../services/auth-header";

export const auditlogs = {
  namespaced: true,
  state: {
    logs: [],
  },
  getters: {
    getAuditLogs: (state) => state.logs,
  },
  mutations: {
    setLogs(state, logs) {
      state.logs = logs;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      return axios
        .get(apiURL, { headers: authHeader() })
        .then((res) => {
          commit("setLogs", res.data);
          return res;
        })
        .catch((error) => error.response);
    },
    async search({ commit }, filter) {
      return axios
        .post(apiURL + "search", filter, { headers: authHeader() })
        .then((res) => {
          commit("setLogs", res.data);
          return res;
        })
        .catch((error) => error.response);
    },
  },
};
